/**
 * @description 录音功能 拿到录音数据即刻返回
 * @type {{_audioCtx: null, startRecorder(*, *=): void, _processor: null, _isRecorderIng: boolean, stopRecorder(): void}}
 */
class FJRecorder {
    constructor() {
        this._processor = null;
        this._audioCtx = true;
        this._isRecorderIng = false;

        this._frequencyAudioContext = null;
        this._mediaRecorder = null;
        this._stream = null;

    }

    get stream () {
        return this._stream;
    }

    set stream (stream) {
        this._stream = stream;
    }

    get mediaRecorder () {
        return this._mediaRecorder;
    }

    set mediaRecorder (mediaRecorder) {
        this._mediaRecorder = mediaRecorder;
    }

    get frequencyAudioContext () {
        return this._frequencyAudioContext;
    }

    set frequencyAudioContext (frequencyAudioContext) {
        this._frequencyAudioContext = frequencyAudioContext;
    }

    get processor () {
        return this._processor;
    }

    set processor (processor) {
        this._processor = processor;
    }

    get isRecorderIng () {
        return this._isRecorderIng;
    }

    set isRecorderIng (isRecorderIng) {
        this._isRecorderIng = isRecorderIng;
    }

    get audioCtx () {
        return this._audioCtx;
    }

    set audioCtx (audioCtx) {
        this._audioCtx = audioCtx;
    }

    startRecorder (constraints, options= {}) {
        if (navigator.mediaDevices === undefined) {
            navigator.mediaDevices = {};
        }

        try {
            this.isRecorderIng = true;

            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = function (constraints) {
                    // 首先，如果有getUserMedia的话，就获得它
                    const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

                    // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
                    if (!getUserMedia) {
                        throw new Error('No Support');
                    }

                    // 否则，为老的navigator.getUserMedia方法包裹一个Promise
                    return new Promise(function (resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                };
            }

            if (!navigator.mediaDevices.getUserMedia) {
                throw new Error('No Support');
            }

            const { onProgress = () => {}, failCallback = () => {} } = options;

            navigator.mediaDevices
                .getUserMedia(constraints)
                .then(stream => {
                    const track = stream.getAudioTracks()[0];
                    track.addEventListener("ended", () => {
                        failCallback('ended');
                    });
                    // 音频参数
                    this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                    const source = this.audioCtx.createMediaStreamSource(stream);

                    // 创建音频处理节点
                    this.processor = this.audioCtx.createScriptProcessor(4096, 1, 1);

                    this.processor.onaudioprocess = (e) => {
                        if (this.isRecorderIng) {
                            onProgress(e);
                        }
                    };

                    // 连接节点
                    source.connect(this.processor);
                    // 必须
                    this._processor.connect(this.audioCtx.destination);

                }).catch(error => {
                    if (error === 'getUserMedia is not implemented in this browser') {
                        failCallback('No Support');
                    } else {
                        failCallback(error)
                    }
            });
        } catch (e) {
            failCallback(e);
        }
    };

    /**
     * @description 停止录音
     */
    stopRecorder () {
        this.isRecorderIng = false;
        this.processor?.disconnect(this.audioCtx?.destination);

        this.processor = null;
        this.audioCtx = null;
    };


    previewRecorder (constraints, options) {
        const { callback = () => {}, failCallback = () => {} } = options;

        if (navigator.mediaDevices === undefined) {
            navigator.mediaDevices = {};
        }

        try {
            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = function (constraints) {
                    // 首先，如果有getUserMedia的话，就获得它
                    const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

                    // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
                    if (!getUserMedia) {
                        throw new Error('No Support');
                    }

                    // 否则，为老的navigator.getUserMedia方法包裹一个Promise
                    return new Promise(function (resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                };
            }

            if (!navigator.mediaDevices.getUserMedia) {
                throw new Error('No Support');
            }

            navigator.mediaDevices
                .getUserMedia(constraints)
                .then(stream => {
                    const track = stream.getAudioTracks()[0];
                    track.addEventListener("ended", () => {
                        failCallback('ended');
                    });

                    this.stream = stream;
                    this.frequencyAudioContext = new (window.AudioContext || window.webkitAudioContext)();
                    const frequencySource = this.frequencyAudioContext.createMediaStreamSource(this.stream);
                    this.frequencyAudioContext.analyser = this.frequencyAudioContext.createAnalyser();
                    this.frequencyAudioContext.analyser.fftSize = 256;
                    frequencySource.connect(this.frequencyAudioContext.analyser);
                    callback();
                }).catch(error => {
                    if (error === 'getUserMedia is not implemented in this browser') {
                        failCallback('No Support');
                    } else {
                        failCallback(error)
                    }
                });
        } catch (e) {
            failCallback(e)
        }
    }

    stopPreviewRecorder () {
        this.mediaRecorder?.stop();
        this.stream?.getTracks().forEach(track => track.stop());
    }
}

export default FJRecorder;
